import { DOMAIN_LABELS } from '@/lib/compounds';

// Literal class strings (purge-safe) routing through the domain-soft plugin
// (bg-domain-*-tint) + the domain colour tokens, instead of inline alpha hex.
// Keyed by the DOMAIN_LABELS keys (note mental_health → the hyphenated class).
const DOMAIN_CLASS: Record<string, string> = {
  cardiovascular: 'bg-domain-cardiovascular-tint text-domain-cardiovascular border-domain-cardiovascular',
  hormonal: 'bg-domain-hormonal-tint text-domain-hormonal border-domain-hormonal',
  genomics: 'bg-domain-genomics-tint text-domain-genomics border-domain-genomics',
  fitness: 'bg-domain-fitness-tint text-domain-fitness border-domain-fitness',
  gut: 'bg-domain-gut-tint text-domain-gut border-domain-gut',
  neurological: 'bg-domain-neurological-tint text-domain-neurological border-domain-neurological',
  mental_health: 'bg-domain-mental-health-tint text-domain-mental-health border-domain-mental-health',
};
const NEUTRAL = 'bg-surface-sunken text-text-secondary border-border';

export function DomainPill({ domain }: { domain: string }) {
  const label = DOMAIN_LABELS[domain] ?? domain;
  return (
    <span className={`mr-1 inline-block rounded-pill border px-2 py-0.5 text-[11px] font-semibold ${DOMAIN_CLASS[domain] ?? NEUTRAL}`}>
      {label}
    </span>
  );
}
